import {
  Autocomplete, Button, TextField, Typography,
} from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import LANGUAGES_LIST from '../../../../../utils/languages';
import { useNextStepAfterUpdate } from '../Wizard/Wizard.hooks';
import YesNoComponent from './YesNoComponent';

export interface LyricsProps {}

const useStyles = makeStyles()(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  button: {
    marginTop: 16,
    display: 'flex',
    justifyContent: 'flex-end',
  },
}));

const Lyrics: React.FC<LyricsProps> = () => {
  const [hasLyrics, setHasLyrics] = React.useState(false);
  const next = useNextStepAfterUpdate();
  const [lang, setLang] = React.useState<string | undefined>('en');
  const { t } = useTranslation();

  const { classes } = useStyles();
  const handleClick = (lyrics: boolean) => {
    if (lyrics) {
      setHasLyrics(true);
    } else {
      setHasLyrics(false);
      next({ lyrics: false, lang: undefined }, 'vocals');
    }
  };

  const handleLanguageChange = (_event: React.ChangeEvent<{}>, value: string) => {
    setLang(value);
  };

  const handleNext = () => {
    next({ lyrics: true, lang }, 'vocals');
  };

  return (
    <>
      <div className={classes.container}>
        <YesNoComponent handleClick={handleClick} id="lyrics" />
        {hasLyrics && (
          <>
            <Typography variant="body1">{t('home.input.dialog.lyrics.language')}</Typography>
            <Autocomplete
              renderInput={(params) => (
                <TextField {...params} label={t('home.input.dialog.lyrics.language_select')} />
              )}
              defaultValue="en"
              options={Object.keys(LANGUAGES_LIST)}
              getOptionLabel={(option) => LANGUAGES_LIST[option as keyof typeof LANGUAGES_LIST]}
              onChange={handleLanguageChange}
            />
          </>
        )}
      </div>
      {hasLyrics && (
        <div className={classes.button}>
          <Button variant="contained" id="btn_wizard_lyrics_next" onClick={handleNext}>
            {t('home.input.dialog.next')}
          </Button>
        </div>
      )}
    </>
  );
};

export default Lyrics;
